import { Link } from 'react-router-dom'
import DefaultIcon from '../../../../assets/dashboard/course-default-icon.png'
import { Card, List as ListContainer, EmptyText, LoadingContent } from './styles'
import { TMessage } from './types'
import { TMessageOrigin } from '../../../../tracking/types'

interface IProps {
  data: TMessage[]
  isLoading?: boolean
  error?: any
}

const List = (props: IProps) => {
  if (props.isLoading) {
    return (
      <LoadingContent>
        <div className="loading-block"></div>
        <div className="loading-block"></div>
        <div className="loading-block"></div>
        <div className="loading-block"></div>
      </LoadingContent>
    )
  }

  if (props.data.length === 0 && !props.isLoading) {
    return (
      <EmptyText>
        <h1 className="empty-text">Você não possui recados</h1>
      </EmptyText>
    )
  }

  return (
    <ListContainer>
      {props.data.map((item, idx) => (
        <Card data-read={item.read} key={idx}>
          <div className="content">
            <div className="wrapper">
              <img src={DefaultIcon} className="icon" alt="Logo da Direção Concursos" />
              <div className="texts">
                <Link to={`/course/${item.courseInfo.course._id}`} className="course-name link">
                  {item.courseInfo.course.name}
                </Link>

                <p>
                  <strong className="label">Módulo:</strong>
                  <Link
                    to={`/course/${item.courseInfo.course._id}/module/${item.courseInfo.module._id}/lesson/${item.courseInfo.lesson._id}/chapter/${item.courseInfo.chapter._id}`}
                    className="link"
                  >
                    {item.courseInfo.module.name}
                  </Link>
                </p>
                <p>
                  <strong className="label">Professor:</strong>
                  <span className="text">{item.professor.name}</span>
                </p>
                <p>
                  <strong className="label">Assunto:</strong>
                  <span className="text">{item.subject}</span>
                </p>
              </div>
            </div>

            <p
              className="short-description"
              dangerouslySetInnerHTML={{ __html: item.message }}
              ref={(node) => {
                if (!node) return
                node.innerHTML = node.textContent
              }}
            ></p>
          </div>
          <div className="footer">
            <p className="date">Enviada em {formatDate(item.createdAt)}</p>

            <Link
              to={{
                pathname: `/recado/${item._id}`,
                state: { origin: 'Pagina de Recados' as TMessageOrigin },
              }}
              className="link"
            >
              Ver mais
            </Link>
          </div>
        </Card>
      ))}
    </ListContainer>
  )
}

const formatDate = (date: string) =>
  new Intl.DateTimeFormat('pt-BR', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(date))

export default List
